import { NotificationTypes } from '../models/notification/notification';
import React from 'react';

export function notificationBadgeConverter(type: NotificationTypes) {
  switch (type) {
    case 'WEBINAR_JOINED':
    case 'EARNED_A_BADGE':
      return 'event';
    case 'BULLPEN_APPLICATIONS_OPEN':
      return 'bullpen';
    case 'CHALLENGE_JOINED':
      return 'challenge';
    default:
      return 'tag';
  }
}

export function notificationTextFormatters({
  emphasis,
}: {
  emphasis: (text: string) => React.ReactNode;
}) {
  function formatWorkshopJoinedNotification({
    userName,
    workshopName,
  }: Record<'userName' | 'workshopName', string>) {
    return (
      <>
        {emphasis(userName)} joined to the {emphasis(workshopName)} workshop
      </>
    );
  }

  function formatWebinarJoinedNotification({
    userName,
    webinarName,
  }: Record<'userName' | 'webinarName', string>) {
    return (
      <>
        {emphasis(userName)} joined to the {emphasis(webinarName)} webinar
      </>
    );
  }

  function formatChallengeJoinedNotification({
    userName,
    challengeName,
  }: Record<'userName' | 'challengeName', string>) {
    return (
      <>
        {emphasis(userName)} joined to the {emphasis(challengeName)} challenge
      </>
    );
  }

  function formatEarnedABadgeNotification({
    userName,
    badgeName,
  }: Record<'userName' | 'badgeName', string>) {
    return (
      <>
        {emphasis(userName)} earned a {emphasis(badgeName)} badge
      </>
    );
  }

  function formatApplicationsOpenNotification({
    bullpen,
  }: Record<'bullpen', string>) {
    return <>Applications for the {emphasis(bullpen)} are now open</>;
  }

  function formatNotification(
    type: NotificationTypes,
    data: Record<'userName' | 'eventName', string>
  ) {
    switch (type) {
      case 'WORKSHOP_JOINED':
        return formatWorkshopJoinedNotification({
          userName: data?.userName,
          workshopName: data?.eventName,
        });
      case 'WEBINAR_JOINED':
        return formatWebinarJoinedNotification({
          userName: data?.userName,
          webinarName: data?.eventName,
        });
      case 'CHALLENGE_JOINED':
        return formatChallengeJoinedNotification({
          userName: data?.userName,
          challengeName: data?.eventName,
        });
      case 'EARNED_A_BADGE':
        return formatEarnedABadgeNotification({
          userName: data?.userName,
          badgeName: data?.eventName,
        });
      case 'BULLPEN_APPLICATIONS_OPEN':
        return formatApplicationsOpenNotification({
          bullpen: data?.eventName,
        });
      default:
        return null;
    }
  }

  return {
    formatWorkshopJoinedNotification,
    formatWebinarJoinedNotification,
    formatChallengeJoinedNotification,
    formatEarnedABadgeNotification,
    formatApplicationsOpenNotification,
    formatNotification,
  };
}
